import { IOrderSystemNotification, IOrderSystemNotificationValidation } from '../types';
import { defaulLangTextValidation, defaultTTranslate } from 'src/constants/main';

export const maxOrderSystemNotificationOtpLength: number = 60;

export const defaultOrderSystemNotification: IOrderSystemNotification = {
  otp: defaultTTranslate,
  address: defaultTTranslate,
  refund: defaultTTranslate,
};

export const defaultOrderSystemNotificationValidation: IOrderSystemNotificationValidation = {
  isValid: true,
  otp: defaulLangTextValidation,
  address: defaulLangTextValidation,
  refund: defaulLangTextValidation,
};
